module.exports = __webpack_public_path__ + "img/culture_5.b38f72fc.jpg";